function loadM34(color, area) {

    var first = new fabric.Text('AMANDA', {
        isOnlyLetter: true,
        fill: color,
        fontFamily: 'Copperplate Gothic Bold',
        fontSize: 9,
        left: 5,
        top: 20,
        originX: 'center',
        originY: 'center',
        letterPosition: 'first',
        isWord: true
    });

    var middle = new fabric.Text('L', {
        isOnlyLetter: true,
        fill: color,
        fontFamily: 'Copperplate Gothic Light',
        fontSize: 60,
        left: 0,
        top: 55,
        originX: 'center',
        originY: 'center',
        letterPosition: 'middle',
        isWord: false
    });

    var last = new fabric.Text('STEVEN', {
        isOnlyLetter: true,
        fill: color,
        fontFamily: 'Copperplate Gothic Bold',
        fontSize: 9,
        left: 7,
        top: 80,
        originX: 'center',
        originY: 'center',
        letterPosition: 'last',
        isWord: true
    });

    var group = new fabric.Group([first, middle, last], {
      hasBorders: false,
      hasControls: true,
      hasRotatingPoint: false,
      selectable: true
    });

    group. height = 75;
    group.left = (area.left + (area.width / 2)) - (group.width / 2);
    group.top = (area.top + (area.height / 2)) - (group.height / 2);

    group.id = 'monogram';
    group.code = 'M34';
    group.oldLeft = group.left;

    return group;
};
